/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { changeOrderTemplatesControllerCreate } from "./changeOrderTemplatesControllerCreate";
import { changeOrderTemplatesControllerFindAll } from "./changeOrderTemplatesControllerFindAll";
import { changeOrderTemplatesControllerRemove } from "./changeOrderTemplatesControllerRemove";
import { changeOrderTemplatesControllerUpdate } from "./changeOrderTemplatesControllerUpdate";

export function changeOrderTemplatesService() {
  return { changeOrderTemplatesControllerCreate, changeOrderTemplatesControllerFindAll, changeOrderTemplatesControllerUpdate, changeOrderTemplatesControllerRemove }
}